import React, { useEffect, useState, useRef } from 'react';
import '../shared/sheet-animations.css';
import { connect, useDispatch } from 'react-redux';
import { hairdresserActions } from "../../_actions";

function ClientFiltersPopup({ filters, onSend, onClose, isMobile, isSalonOwner }) {
  const dispatch = useDispatch();
  const [teamMembers, setTeamMembers] = useState(filters?.teamMembers || []);
  const [lastBookedPreset, setLastBookedPreset] = useState(null);
  const [salesPreset, setSalesPreset] = useState(null);
  const [staffList, setStaffList] = useState([]);
  const panelRef = useRef(null);

  const lastBookedOptions = [
    { id: '7d', label: 'Last 7 days', startDate: daysAgo(7) },
    { id: '30d', label: 'Last 30 days', startDate: daysAgo(30) },
    { id: '90d', label: 'Last 90 days', startDate: daysAgo(90) },
    { id: '6m', label: '6+ months ago', endDate: daysAgo(180) },
  ];

  const salesOptions = [
    { id: '0', label: '£0', minSales: 0, maxSales: 0 },
    { id: '<50', label: 'Under £50', minSales: 0, maxSales: 50 },
    { id: '50-500', label: '£50 - £500', minSales: 50, maxSales: 500 },
    { id: '500+', label: '£500+', minSales: 500, maxSales: null },
  ];

  // Detect existing filter state on mount
  useEffect(() => {
    if (filters?.startDate || filters?.endDate) {
      const start = filters.startDate ? new Date(filters.startDate).getTime() : null;
      const end = filters.endDate ? new Date(filters.endDate).getTime() : null;
      const match = lastBookedOptions.find(o => {
        const oStart = o.startDate ? new Date(o.startDate).getTime() : null;
        const oEnd = o.endDate ? new Date(o.endDate).getTime() : null;
        return oStart === start && oEnd === end;
      });
      if (match) setLastBookedPreset(match.id);
    }
    if (filters?.minSales !== null || filters?.maxSales !== null) {
      const match = salesOptions.find(o =>
        o.minSales === filters?.minSales && o.maxSales === filters?.maxSales
      );
      if (match) setSalesPreset(match.id);
    }
  }, []);

  useEffect(() => {
    let hairdresserId = localStorage.getItem("userId");
    dispatch(hairdresserActions.hairdresserStaffRota({
      searchKey: "",
      hairdresserId,
      page: 1,
      listType: 1,
    })).then((res) => {
      if (res?.status === 200) {
        const data = res?.data?.data?.rota;
        if (data?.length > 0) {
          setStaffList(data.filter(s => s?.name));
        }
      }
    });
  }, []);

  function toggleStaffMember(staff) {
    const existing = teamMembers.find(tm => tm.value === staff._id);
    if (existing) {
      setTeamMembers(teamMembers.filter(tm => tm.value !== staff._id));
    } else {
      setTeamMembers([...teamMembers, { value: staff._id, label: staff.name }]);
    }
  }

  function handleDone() {
    const lastBooked = lastBookedOptions.find(o => o.id === lastBookedPreset);
    const sales = salesOptions.find(o => o.id === salesPreset);

    const newFilters = {
      ...filters,
      teamMembers: teamMembers,
      teamMemberNames: teamMembers.length > 0 ? teamMembers.map(tm => tm.label).join(', ') : null,
      startDate: lastBooked?.startDate || null,
      endDate: lastBooked?.endDate || null,
      minSales: sales?.minSales ?? null,
      maxSales: sales?.maxSales ?? null,
    };
    onSend(newFilters);
    onClose();
  }

  function handleReset() {
    setTeamMembers([]);
    setLastBookedPreset(null);
    setSalesPreset(null);
  }

  const activeCount = teamMembers.length + (lastBookedPreset ? 1 : 0) + (salesPreset ? 1 : 0);

  const pillStyle = (active) => ({
    padding: isMobile ? '8px 14px' : '6px 12px',
    borderRadius: isMobile ? '999px' : '6px',
    fontSize: '13px',
    fontWeight: '500',
    border: active ? (isMobile ? 'none' : '1px solid #29282D') : '1px solid #e5e5e5',
    backgroundColor: active ? (isMobile ? '#29282D' : '#f0f9ff') : 'white',
    color: active ? (isMobile ? 'white' : '#29282D') : '#4b5563',
    cursor: 'pointer',
    transition: 'all 0.15s',
  });

  const sectionLabelStyle = {
    fontSize: '12px',
    fontWeight: '600',
    color: '#737373',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '8px',
    marginTop: 0,
  };

  const filterSections = (
    <>
      {/* Team member filter - only for salon owners */}
      {isSalonOwner && staffList.length > 0 && (
        <div style={{ marginBottom: '16px' }}>
          <p style={sectionLabelStyle}>Team member</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {staffList.map((staff) => (
              <button
                key={staff._id}
                onClick={() => toggleStaffMember(staff)}
                style={pillStyle(teamMembers.some(tm => tm.value === staff._id))}
              >
                {staff.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Last booked filter */}
      <div style={{ marginBottom: '16px' }}>
        <p style={sectionLabelStyle}>Last booked</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {lastBookedOptions.map((option) => (
            <button
              key={option.id}
              onClick={() => setLastBookedPreset(lastBookedPreset === option.id ? null : option.id)}
              style={pillStyle(lastBookedPreset === option.id)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Sales filter */}
      <div style={{ marginBottom: '16px' }}>
        <p style={sectionLabelStyle}>Total sales</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {salesOptions.map((option) => (
            <button
              key={option.id}
              onClick={() => setSalesPreset(salesPreset === option.id ? null : option.id)}
              style={pillStyle(salesPreset === option.id)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );

  const footer = (mobile) => (
    <div style={{
      display: 'flex',
      justifyContent: mobile ? 'stretch' : 'space-between',
      gap: mobile ? '8px' : '0',
      paddingTop: '12px',
      borderTop: '1px solid #e5e5e5',
    }}>
      <button
        onClick={handleReset}
        style={{
          flex: mobile ? 1 : undefined,
          padding: mobile ? '14px' : '8px 16px',
          border: mobile ? '1px solid #e5e5e5' : 'none',
          borderRadius: mobile ? '10px' : '6px',
          backgroundColor: mobile ? 'white' : 'transparent',
          color: '#737373',
          fontSize: mobile ? '15px' : '13px',
          fontWeight: '500',
          cursor: 'pointer',
        }}
      >
        Reset all
      </button>
      <button
        onClick={handleDone}
        style={{
          flex: mobile ? 1 : undefined,
          padding: mobile ? '14px' : '8px 20px',
          border: 'none',
          borderRadius: mobile ? '10px' : '6px',
          backgroundColor: '#29282D',
          color: 'white',
          fontSize: mobile ? '15px' : '13px',
          fontWeight: '600',
          cursor: 'pointer',
        }}
      >
        Done
      </button>
    </div>
  );

  // Mobile: bottom sheet
  if (isMobile) {
    return (
      <>
        <div
          className="sheet-anim-backdrop"
          style={{ position: 'fixed', inset: 0, zIndex: 200, backgroundColor: 'rgba(0,0,0,0.4)' }}
          onClick={onClose}
        />
        <div className="sheet-anim-up" style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white',
          borderRadius: '16px 16px 0 0',
          boxShadow: '0 -4px 40px rgba(0, 0, 0, 0.15)',
          zIndex: 201,
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}>
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid #e5e5e5',
            flexShrink: 0,
          }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', margin: 0 }}>Filters</h3>
            <button
              onClick={onClose}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                border: 'none',
                backgroundColor: '#f3f4f6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontSize: '16px',
                color: '#1a1a1a',
              }}
            >
              &#x2715;
            </button>
          </div>

          {/* Scrollable body */}
          <div style={{
            flex: 1,
            overflowY: 'auto',
            padding: '16px 20px 0',
          }}>
            {filterSections}
          </div>

          {/* Sticky footer */}
          <div style={{
            padding: '0 20px',
            paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
            flexShrink: 0,
          }}>
            {footer(true)}
          </div>
        </div>
      </>
    );
  }

  // Desktop: dropdown panel
  return (
    <>
      <div
        style={{ position: 'fixed', inset: 0, zIndex: 99 }}
        onClick={onClose}
      />
      <div
        ref={panelRef}
        style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: '8px',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          border: '1px solid #e5e5e5',
          zIndex: 100,
          width: '360px',
          padding: '16px',
        }}
      >
        {filterSections}
        {footer(false)}
      </div>
    </>
  );
}

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  d.setHours(0, 0, 0, 0);
  return d;
}

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(ClientFiltersPopup);
